import React from "react";

import _Calendar from "./Calendar.elm";
import { getJwt } from "utilities/authentication";
import { useUserInfo } from "modules/Dashboard/UserInfo";
import styles from "./styles.scss";
import { Elm } from "components/Elm";
import getServerRootUrl, { getHaskellBackendUrl, getRustBackendUrl } from "utilities/getServerRootUrl";

export default function Calendar() {
  const { me, loading } = useUserInfo();

  if (!me || loading) return null;

  return (
    <div className={styles.elmContainer}>
      <Elm
        src={_Calendar.Elm.Calendar}
        flags={{
          userId: me.id,
          jwt: getJwt(),
          serverUrl: `${getServerRootUrl()}/graphql`,
          haskellBackendBaseUrl: getHaskellBackendUrl(),
          rustBackendBaseUrl: getRustBackendUrl(),
        }}
      />
    </div>
  );
}
